import BookmarksGenerateForm from './BookmarksGenerateForm';
export default BookmarksGenerateForm;